import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { TrainingCoursesCoordinatorsApiModel } from '@app/api/api-models';
import { UserListApiModel } from '@app/api/api-models/users/UserListApiModel';
import { ExistedUsers } from '@app/shared/models';

@Injectable()
export class TrainingCoursesCoordinatorsService {
  public apiUrl = 'training-courses-coordinators';

  constructor(private readonly http: HttpClientService) {}

  getCoordinators(): Observable<TrainingCoursesCoordinatorsApiModel[]> {
    return this.http.get<TrainingCoursesCoordinatorsApiModel[]>(`${this.apiUrl}`);
  }

  addCoordinators(coordinatorsList: ExistedUsers): Observable<TrainingCoursesCoordinatorsApiModel[]> {
    return this.http.post<TrainingCoursesCoordinatorsApiModel[]>(`${this.apiUrl}/create`, coordinatorsList);
  }

  getAvailableUsers(): Observable<UserListApiModel[]> {
    return this.http.get<UserListApiModel[]>(`${this.apiUrl}/available-users`);
  }

  removeCoordinator(userId: string): Observable<void> {
    return this.http.delete(`${this.apiUrl}/${userId}`);
  }
}
